define([], function() {
	if(Object.assign === undefined) {
		Object.assign = function(obj1, obj2) {
			for(var key in obj2) {
				obj1[key] = obj2[key];
			}
			return obj1;
		};
	}
});